import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import store from './store'
import './plugins/axios'
import './global.scss'
Vue.config.productionTip = false

// global compponents
import Default from './layouts/Default'
import NoSidebar from './layouts/NoSidebar'


import lsSync from './utils/localstorageSync'
lsSync.syncData()

Vue.component('default-layout', Default)
Vue.component('no-sidebar-layout', NoSidebar)

new Vue({
  router,
  vuetify,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
